import { useAiSlidePanel } from "@redotech/redo-web/ai/chat/contexts/ai-slide-panel-context";
import { useAskRedoSlidePanel } from "./ask-redo-slide-panel-context";

export interface AiChatPanelState {
  isOpen: boolean;
  panelWidth: number;
}

/**
 * Combined open-state + width of the AI chat slide panel, covering
 * legacy slide-panel state and the new Ask Redo slide-out. The two
 * panels keep deliberately separate open/close state (see
 * `ask-redo-slide-panel-context.tsx`), so any
 * surface that positions itself relative to "the chat panel" — e.g.
 * a fixed drawer that shifts left so it doesn't cover the chat —
 * must consult both. Reading only `useAiSlidePanel()` misses the Ask
 * Redo panel state.
 *
 * `panelWidth` comes from the legacy context for both panels: every
 * `AiSlidePanelLayout` instance (legacy and Ask Redo) reports its
 * width there on mount and on resize, and all instances share one
 * localStorage width preference, so the value is correct whichever
 * panel is open.
 */
export function useAiChatPanelState(): AiChatPanelState {
  const { isOpen: legacyOpen, panelWidth } = useAiSlidePanel();
  const { isOpen: askRedoOpen } = useAskRedoSlidePanel();
  return { isOpen: legacyOpen || askRedoOpen, panelWidth };
}
